/**
 * Version: 1.0.0
 * Description: Custom Scripts for Product Details Totem Road Flex 5.3.2
 * Author: Spherify Pty Ltd
 * Date: 10/04/2025
 */

window.addEventListener('load', function () {
    /**
     * Toggles the collapsible sections for Product Details
     */
    function toggleCollapsible(event) {
        const toggleButton = event.target.closest('.product-subheading');
        if (!toggleButton) return;

        const section = toggleButton.closest('.product-section-collapsible');
        const content = section.querySelector('.product-collapsible-content');
        const icon = section.querySelector('.icon.plus');

        if (content.style.display === 'block') {
            content.style.display = 'none';
            icon.style.transform = 'rotate(0deg)';
        } else {
            content.style.display = 'block';
            icon.style.transform = 'rotate(45deg)';
        }
    }

    /**
     * Set up click handlers for collapsible sections
     */
    function setupCollapsibleSections() {
        document.addEventListener('click', function (event) {
            const toggleButton = event.target.closest('.product-section-collapsible .product-subheading');
            if (toggleButton) {
                toggleCollapsible(event);
            }
        });
    }

    /**
     * Render product dimensions
     */
    function renderDimensions() {
        const dataElement = document.getElementById('dimension-data');
        const dimensionsContainer = document.getElementById('dimension-output');
        if (dataElement && dimensionsContainer) {
            let formattedText = '';
            try {
                const data = JSON.parse(dataElement.textContent);
                if (Array.isArray(data)) {
                    data.forEach((dimensionText) => {
                        let splitText = dimensionText.split('|');

                        if (splitText.length === 2) {
                            let leftSide = splitText[0].trim();
                            let rightSide = splitText[1].trim();
                            if (leftSide && rightSide) {
                                formattedText += `<div class="dimension-set">
                                    <div class="dimension-heading"><strong>${leftSide}</strong></div>
                                    <div class="dimension-value">${rightSide}</div>
                                </div>`;
                            }
                        }
                    });
                } else {
                    console.error("Expected an array of dimensions");
                    formattedText = dataElement.textContent;
                }
            } catch (e) {
                console.error("Error parsing dimension data:", e);
                formattedText = dataElement.textContent;
            }
            dimensionsContainer.innerHTML = formattedText;
        }
    }

    // Initialize functionality
    setupCollapsibleSections();
    renderDimensions();
}); 